import { randomInt } from "../../shared/rng";
import type { Transport } from "./transport";

/**
 * Плохая сеть на одном ПК: настоящий канал плюс задержка в одну сторону, дрожание и потери (?lag=150 в адресе).
 * Для проверки онлайна в двух вкладках до замера между странами.
 */
export function laggy(
  inner: Transport,
  delayMs: number,
  jitterMs: number,
  lossPercent: number,
  seed: number,
): Transport {
  let rng = seed | 0 || 1;
  const roll = (range: number): number => {
    const next = randomInt(rng, range);
    rng = next.state;
    return next.value;
  };
  return {
    send: (bytes) => {
      if (roll(100) < lossPercent) return;
      const jitter = jitterMs > 0 ? roll(jitterMs * 2 + 1) - jitterMs : 0;
      const copy = bytes.slice();
      setTimeout(
        () => {
          inner.send(copy);
        },
        Math.max(0, delayMs + jitter),
      );
    },
    onMessage: (handler) => {
      inner.onMessage(handler);
    },
    close: () => {
      inner.close();
    },
  };
}
